var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emd-modal", {
    attrs: { "has-header": "", "has-footer": "", open: _vm.isOpen },
    on: {
      close: function ($event) {
        return _vm.$emit("onClose")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "h2",
              { staticClass: "emd-text _size_section _color_contrast" },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("modal.pix.modal-create-key.title")) + " "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _vm.error
              ? _c(
                  "emd-alert",
                  {
                    attrs: {
                      variant: "danger",
                      title: _vm.$t("alert.error-title"),
                    },
                    on: {
                      cancel: function ($event) {
                        _vm.error = null
                      },
                    },
                  },
                  [
                    _c("template", { slot: "content" }, [
                      _vm._v(" " + _vm._s(_vm.error) + " "),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
            _c("jade-checkbox", {
              attrs: {
                id: "create-key-checkbox",
                name: "create-key-checkbox",
                value: _vm.isCheck,
                label: _vm.$t("modal.pix.modal-create-key.paragraph-1"),
              },
              on: {
                "update:value": function ($event) {
                  _vm.isCheck = $event
                },
              },
            }),
            _c("password-confirmation", {
              staticClass: "eu-mt_5",
              attrs: {
                name: "input-password",
                "data-testid": "input-password",
              },
              model: {
                value: _vm.password,
                callback: function ($$v) {
                  _vm.password = $$v
                },
                expression: "password",
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "eu-flex-item eu-align_right" },
              [
                _c(
                  "emd-button",
                  {
                    attrs: {
                      "data-testid": "button-cancel",
                      type: "text",
                      disabled: _vm.isValidate,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("onCancel")
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("modal.pix.modal-create-key.button-cancel")
                        ) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "emd-button",
                  {
                    attrs: {
                      color: "primary",
                      "data-testid": "button-confirm",
                      disabled: _vm.isValidate,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onSubmit()
                      },
                    },
                  },
                  [
                    _vm.isLoad
                      ? _c("emd-loader", { attrs: { type: "" } })
                      : _vm._e(),
                    !_vm.isLoad
                      ? _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "modal.pix.modal-create-key.button-confirm"
                                )
                              ) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }